import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomImage from 'designer/component/element/Image'

export const ImageSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomImage {...props} />
  </DragElementWrapper>
)

export const ImageDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomImage {...props} />
  </ElementWrapper>
)

export const imageTester = rankWith(1000, scopeEndsWith('image'))
